import { render, staticRenderFns } from "./bd_uniform.vue?vue&type=template&id=a70c72a8"
import script from "./bd_uniform.vue?vue&type=script&lang=js"
export * from "./bd_uniform.vue?vue&type=script&lang=js"
import style0 from "./bd_uniform.vue?vue&type=style&index=0&id=a70c72a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports